import { TabItem } from '@components/Tabs/Tabs.types';
import GlobalIntlSingleton from '@setup/intl/GlobalIntlSingleton';
import { NavigateFunction } from 'react-router-dom';
import BasicCustomerInfo from './BasicCustomerInfo/BasicCustomerInfo';
import { NomineeCustomer } from '@features/api/response/NomineeCustomer';
import NomineeCustomerInvestments from '@pages/NomineeCustomer/NomineeCustomerInvestments/NomineeCustomerInvestments';

export const NomineeCustomerTabIds = [
  'basic-details',
  'reporting',
  'transactions',
] as const;
export type CustomerDetailsTabIds = typeof NomineeCustomerTabIds[number];
export type CustomerDetailTabItem = Omit<TabItem, 'id'> & {
  id: CustomerDetailsTabIds;
};

export const getCustomerDetailsTabs = (
  navigate: NavigateFunction,
  customer?: NomineeCustomer,
  customerId?: number | string
): CustomerDetailTabItem[] => [
  {
    id: 'basic-details',
    label: GlobalIntlSingleton.intl.formatMessage({
      id: 'crm.customer.basicDetailsTab',
    }),
    component: <BasicCustomerInfo customer={customer} />,
    tabProps: {
      value: 'basic-details',
      onClick: () => navigate(`/crm/customer/basic-details/${customerId}`),
    },
  },
  {
    id: 'transactions',
    label: GlobalIntlSingleton.intl.formatMessage({
      id: 'crm.customer.transactionsTab',
    }),
    component: <NomineeCustomerInvestments customer={customer} />,
    tabProps: {
      value: 'transactions',
      onClick: () => navigate(`/crm/customer/transactions/${customerId}`),
    },
  },
];
